<template>
  <div :class="classList">
    <i class="color-block" :class="`${riskLevel}-risk-color`"></i>
    <span v-if="riskLevel.toLowerCase() === 'low'">LOW</span>
    <span v-if="riskLevel.toLowerCase() === 'medium'">MEDIUM</span>
    <span v-if="riskLevel.toLowerCase() === 'high'">HIGH</span>
  </div>
</template>
<script>
import { RiskLevelScoreEnum } from "@/constants/risk-level.constants";

export default {
  name: "RiskLevelButton",
  props: {
    riskLevel: { type: String, default: "low" },
    classList: { type: String }
  },
  data() {
    return {
      RiskEnum: RiskLevelScoreEnum
    };
  },
  methods: {
    buttonClick() {}
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";
</style>



// WEBPACK FOOTER //
// src/components/button/RiskLevelButton.vue